import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useImperativeHandle, useRef } from "react";
import { MenuElement } from "./MenuElement.js";
import { eramFontDimensionMap, eramFontNameMap } from "../../eramFont.js";
import { colorNameMap } from "../../colorNameMap";
import { useWindowSize } from "usehooks-ts";
import { usePixiOnClickOutside } from "../hooks/usePixiOnClickOutside.js";
const fontName = eramFontNameMap[2];
const { width: fontWidth, height: fontHeight } = eramFontDimensionMap[fontName];
export const EramPrompt = ({ ref, title, pos, height, startDrag, zIndex, showX = false, closeOnClickOutside = false, eventMode = "static", borderTint = colorNameMap.veryDarkGrey, ...props }) => {
    const localRef = useRef(null);
    const windowSize = useWindowSize();
    const width = props.width ?? title.length * fontWidth + 8 + (showX ? fontHeight : 0);
    const xX = width - fontHeight;
    useImperativeHandle(ref, () => {
        return localRef.current;
    }, []);
    usePixiOnClickOutside(localRef, () => {
        if (closeOnClickOutside) {
            props.closeMenu();
        }
    });
    const x = Math.max(0, Math.min(windowSize.width - width, pos.x));
    const y = Math.max(0, Math.min(windowSize.height - height, pos.y));
    return (_jsxs("container", { ref: localRef, x: x, y: y, sortableChildren: true, zIndex: zIndex, eventMode: eventMode, children: [_jsx(MenuElement, { x: 0, y: 0, width: showX ? xX : width, text: title, onmousedown: startDrag }), showX && _jsx(MenuElement, { x: xX, y: 0, width: fontHeight, text: "X", onmousedown: props.closeMenu }), _jsxs("container", { y: fontHeight + 2, children: [_jsx("graphics", { draw: (graphics) => {
                            graphics.clear();
                            graphics.rect(0, 0, width, height).fill(0).stroke({ width: 1, color: borderTint });
                        } }), _jsx("container", { zIndex: 1, sortableChildren: true, children: props.children })] })] }));
};
//# sourceMappingURL=EramPrompt.js.map